module.exports = __webpack_public_path__ + "img/about3.ebe5bcc2.webp";